import { render, staticRenderFns } from "./stream-route-index.vue?vue&type=template&id=6b7881f6&scoped=true&"
import script from "./stream-route-index.vue?vue&type=script&lang=js&"
export * from "./stream-route-index.vue?vue&type=script&lang=js&"
import style0 from "./stream-route-index.vue?vue&type=style&index=0&id=6b7881f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7881f6",
  null
  
)

export default component.exports